import Config from '@/config'

const MESSAGE_TYPES = {
  ACCOUNT_REMOVAL: 'account-removal',
  ACTIVE_ONE_TIME: 'active-one-time',
}

function handleAccountRemoval() {
  window.location.href = Config.accountRemovalURL
}

function handleActiveOneTimePlan(doc, editor) {
  editor.$store.state.currentUser.oneTimeEnd = doc.data
}

const AccountRemovalWebSocketSubscriber = {
  [MESSAGE_TYPES.ACCOUNT_REMOVAL]: handleAccountRemoval,
  [MESSAGE_TYPES.ACTIVE_ONE_TIME]: handleActiveOneTimePlan,
}

export default AccountRemovalWebSocketSubscriber
